<template>
  <div class="wallet-agreement">
    <h1>中信银行e管家业务平台子商户服务协议</h1>
    <p>编号：</p>
    <p>甲方：中信银行股份有限公司    分行</p>
    <p>负责人：【】</p>
    <p>住所： 【】</p>
    <p>乙方：【】（以下亦简称"平台子商户"）</p>
    <p>法定代表人：【】</p>
    <p>住所地：【】</p>
    <p>甲方与                    有限公司（以下简称"平台"）已签署编号为【】的《中信银行e管家业务合作协议》（以下简称"合作协议"），甲方根据合作协议为平台及平台子商户提供e管家交易资金结算管理服务，本协议是由甲方与乙方就e管家交易资金结算管理服务等相关事项所订立的有效合约。</p>
    <p><strong>特别提示</strong></p>
    <p>为了维护您（本协议乙方）的利益，请在签署本《中信银行e管家业务平台子商户服务协议》（以下简称"本协议"）前，仔细阅读本协议的各条款，并特别注意如下事项：</p>
    <p>1.基于甲方与平台签订的合作协议，以及乙方与平台的业务合作关系，甲方为平台及乙方提供交易资金结算管理相关服务。本协议由乙方与甲方签署，本协议签署且乙方通过平台在甲方开立资金登记簿后视为乙方同意接受甲方提供本协议项下相关服务，且乙方充分知悉和理解了本协议项下各方（甲方、乙方、平台）的各项权利义务。</p>
    <p>乙方在平台渠道通过网络点击"签署"或"同意"的方式签署本协议即表示乙方已充分知悉和理解本协议的全部内容并接受本协议的各项约束。在接受本协议之前，乙方应仔细阅读本协议的全部内容（特别是以加粗、加黑、突出显示等方式标注的内容），乙方有权选择接受或不接受本协议条款。如乙方选择不接受本协议，甲方将无法为乙方提供在平台上的交易资金结算管理相关服务。</p>
    <p>乙方知悉并同意，乙方在本协议项下向甲方提交的指令需通过平台或平台授权的技术服务商系统与甲方系统接口对接或其他甲方认可的方式由平台向甲方提交，甲方根据平台提交的业务指令进行与乙方相关的业务操作，包括但不限于入金、划转、出金、查询及对账等，该等操作指令已获乙方合法有效授权，该等指令的真实性、准确性、完整性、合法性、有效性均由乙方和平台负责，如该等指令未经乙方授权，或指令信息有误等，甲方不承担任何责任，由乙方与平台自行解决。</p>
    <p>乙方通过平台在甲方开立的资金登记簿，是专门用于记载乙方在平台上的交易资金变动明细和余额的资金明细台账。该资金登记簿非真实银行账户，乙方与甲方之间不构成实际的存款法律关系，甲方仅根据平台发送的业务系统指令为乙方登记出入金明细及其他资金划转明细。</p>
    <p>如甲方与平台签署的相关业务合作协议失效，或乙方与平台之间的服务协议失效或合作关系解除，则本协议也随之失效，乙方通过平台在甲方开立的资金登记簿随之作废。</p>
    <p><strong>第一条 定义</strong></p>
    <p>（一）甲方：指与平台签署《中信银行e管家业务合作协议》并为平台及乙方提供交易资金结算管理服务的中信银行股份有限公司分支机构。</p>
    <p>（二）乙方：即平台子商户，是指符合平台准入条件加入平台业务经营体系，根据平台制定的交易规则进行相关商品或服务交易（含实体经营场所线下交易或使用平台/交易系统线上交易）的经营主体，包括个体工商户和企业。</p>
    <p>（三）e管家：是指中信银行为平台及平台子商户提供的集交易资金代收、用户预存资金管理、交易待清算资金管理、资金跨行清分、查询对账等服务于一体的线上全流程交易资金结算管理产品。</p>
    <p>（四）交易资金账户：是指甲方为平台开立的银行专用内部账户或平台在甲方开立的单位银行结算账户，专门用于核算e管家业务的平台子商户交易资金，平台根据子商户授权，通过与甲方对接的系统向甲方发送e管家业务系统指令来转移账户资金。交易资金账户仅用于接收e管家业务相关资金汇入。</p>
    <p>（五）自有资金账户：是指甲方为平台开立的单位银行结算账户，用于核算合作协议项下合作业务交易相关的支付渠道手续费、业务手续费、清分长短款项、平台营销补贴等相关业务款项等。</p>
    <p>（六）资金登记簿：是指甲方基于平台的交易资金账户为平台和平台子商户建立的专门用于记载其交易资金变动明细和余额的资金明细台账。资金登记簿非真实银行账户，平台、平台子商户与甲方之间不构成实际的存款法律关系，甲方仅根据平台发送的业务系统指令为平台子商户登记出入金明细及其他资金划转明细。</p>
    <p>（七）业务订单：是指乙方在平台上发生交易的真实业务信息描述，作为一次交易的唯一描述对象，业务订单编号用于标识一个订单，具有唯一性。</p>
    <p>（八）平台子商户结算账户：是指乙方用于划转资金及接收提现资金而绑定的银行结算账户。</p>
    <p>（九）绑卡：是指将平台子商户资金登记簿与其平台子商户结算账户建立绑定关系，绑定后可以将该资金登记簿余额提现至对应的平台子商户结算账户。</p>
    <p>（十）提现：是指乙方通过平台发起支付指令后相关资金划转入其绑定的平台子商户结算账户的过程。</p>
    <p><strong>第二条 甲方权利义务</strong></p>
    <p>（一）甲方为平台及乙方提供平台交易资金结算管理相关服务，按照平台指令为乙方办理资金划转及账务明细登记等业务。</p>
    <p>（二）如乙方在平台业务经营活动中，存在违约违规行为或存在因在平台交易而产生的应向平台履行付款义务而未履行的，甲方有权根据平台指令对乙方的交易资金进行冻结或扣划。对乙方与平台在交易过程中产生的一切纠纷，甲方不承担任何责任，由乙方与平台自行解决。</p>
    <p>（三）甲方不提供任何含有甲方对乙方及平台所涉交易资金进行资金监管、托管、存管等在内的服务及职责，甲方提供的本协议项下服务，不应被视为对乙方及平台和其他相关方本身、交易本身以及其他相关行为提供任何形式的承诺或保证担保。甲方不对乙方通过任何方式投入平台交易资金账户的交易资金本金及可能发生的本金受损、交易失败、交易纠纷引起的交易资金受损、或乙方购买平台自行推出或与其他第三方联合推出的各类商品和服务而引起的交易资金受损等承担任何形式的保证或承诺，不承担乙方及平台对交易资金管理运用和处分而引起的任何风险或责任，乙方须自行承担责任和风险。</p>
    <p>（四）甲方提供的服务受平台及平台交易资金账户的制约，如平台交易资金账户因挂失、止付、冻结、扣划等原因不能使用或余额不足，甲方有权中止或终止本协议项下相关服务，乙方同意由其与平台自行协商解决。</p>
    <p>（五）甲方提供的服务受到乙方自身及乙方与平台合作关系的制约，如因包括但不限于乙方与平台发生纠纷、乙方在平台端账号被限制交易、乙方向平台提交的资料不规范或不合法、乙方在平台上发生违法违规行为等原因，导致甲方无法为乙方提供本协议项下相关服务的，由乙方与平台自行协商解决，甲方不承担相关责任。</p>
    <p>（六）因不可归咎于甲方的原因导致乙方或平台中止/终止使用本协议项下服务的，因此导致的乙方无法完成收款、资金结算等相关服务的，乙方和平台自行协商解决，甲方不承担相关责任。若因此导致甲方遭受损失的，甲方有权要求乙方或平台赔偿。</p>
    <p>（七）甲方因以下情况没有执行、未正确执行或未在约定时间内执行乙方或平台指令的，甲方不承担责任：</p>
    <p>1.甲方接收到的指令信息不明、存在乱码、不完整、无法辨认或存在明显信息不匹配等错误的；</p>
    <p>2.平台交易资金账户、平台子商户结算账户被止付、冻结或被有权机关采取其它限制性措施；</p>
    <p>3.平台交易资金账户、自有资金账户或资金登记簿余额不足、被依法冻结或被有权机关采取其它限制性措施的，无法完成资金划转或其他操作的；</p>
    <p>4.乙方或平台操作不当或操作失误的；</p>
    <p>5.由于平台或其授权的技术服务商服务系统导致的其他错误情况；</p>
    <p>6.不可抗力或其它不可归因于甲方的情况。</p>
    <p>（八）乙方授权甲方有权从平台及其授权的技术服务商服务系统获取、查询、下载、复制、打印、使用甲方的账户及交易信息，包括但不限于开户资料、交易流水、对账单等，用于甲方为乙方办理本协议项下业务或办理必要的公证手续使用，及作为资料/证据材料向监管机关、司法机关、仲裁机构提交。甲方有权按照相关法律法规和甲方业务规定的要求，对乙方及乙方通过平台提交的各类文件、资料和信息进行审核。</p>
    <p>（九）甲方有权根据国家相关法律法规、监管要求或自身风险管控要求，针对本协议项下的合作业务制定风险管控策略，并据此对相关账户/交易实施管控，或开展业务检查等，乙方应予以理解并提供必要配合。</p>
    <p>（十）甲方有权对乙方开展反洗钱方面的尽职调查工作，有权根据法律法规、监管规章的规定对乙方资金登记簿采取交易金额、绑定银行账户所有人等方面的限制措施，有权将乙方资金登记簿明细交易纳入机构反洗钱交易监测系统，有权向监管机构及时报告存在可疑交易的乙方账户，有权在接到司法机关查冻扣命令后对乙方资金登记簿维度采取冻结等限制乙方账户提现、转账等措施。</p>
    <p>（十一）甲方有权对出现了人民银行发布的2023年第5期《洗钱风险提示》规定的高风险因素乙方资金登记簿采取诸如限制绑定账户数量、转账金额、转账频率等措施。</p>
    <p>（十二）甲方有权定期人工回溯分析乙方资金登记簿的整体交易流水情况，有权抽查提取乙方资金登记簿的明细交易活动信息，有权增加对乙方异常账目的核对频次。经甲方识别，资金登记簿存在异常交易情形（如持续大额、高频转账或涉司法查冻扣等）的，或乙方多次发生洗钱风险事件的，甲方有权采取中止提供相关服务、解除本协议、暂停或注销资金登记簿等措施。</p>
    <p>（十三）发生以下任一情况，甲方有权要求乙方配合提供乙方在平台的交易数据和其他数据信息、资料影像件等信息进行核查，甲方有权协同平台采取核查、延迟资金结算、限制资金结算金额、暂停或终止本协议项下的服务和报送有关监管部门及公检法部门等所有甲方认为有必要的措施而无需承担任何责任，无需事先征得乙方同意：</p>
    <p>1.乙方在甲方系统内发生身份或其任何银行结算账户识别异常。</p>
    <p>2.甲方有合理理由怀疑乙方利用甲方提供的服务从事赌博、洗钱、套现、传销、淫秽色情等非法活动或为非法活动提供协助及便利的。</p>
    <p>3.乙方被支付清算协会、清算机构、金融监管机构纳入黑名单的；由前述机构纳入黑名单的个人担任法定代表人或者负责人的。</p>
    <p>4.其他甲方认定的违反甲方产品管理规范，触发甲方风险预警情况的。</p>
    <p>（十四）出现以下任一情形时，甲方有权单方面终止本协议并冻结或注销乙方资金登记簿且不承担违约责任，并保留追究乙方责任的权利：</p>
    <p>1.乙方被吊销营业执照，或因任何原因进入破产清算、和解或重整程序。</p>
    <p>2.乙方营业执照或其他登记证件已注销或作废的；</p>
    <p>3.乙方连续6个月无资金交易或信息上送的；</p>
    <p>4.乙方及平台经营的商品或服务品类属于政府、监管部门等有权机构或甲方认定违法违规的，或经营的商品或服务品类属于需事先审批而乙方或平台在正式开办该类业务前未获得相关批文或资质的；</p>
    <p>5.乙方或平台利用甲方系统从事违反国家法律法规活动的；</p>
    <p>6.甲方根据国家相关法律法规、有权机关要求或自身风险管控要求，针对本协议项下的合作业务进行巡检、核查、资料调阅等，乙方或平台拒不配合的；</p>
    <p>7.乙方发生其他违反法律法规或监管要求、违反本协议约定或其他违反甲方业务规定的情形的。</p>
    <p>（十五）甲方有权在根据相关约定与平台解除业务合作时，按照平台指令或要求对平台交易资金账户和乙方资金登记簿内资金进行处置，甲方处置相关资金无需另行征求乙方同意。</p>
    <p>（十六）乙方在使用甲方服务过程中如有疑问，甲方应在法定工作时间内就产品服务等相关事项提供相应的咨询服务和支持。</p>
    <p>（十七）甲方有义务维护业务系统的安全平稳运行，但不可归咎于甲方原因的情形除外。</p>
    <p>（十八）甲方有权基于合理原因（包括但不限于监管原因、风险管理、消费者权益保护、业务需要等）更新和升级甲方系统，由此造成的业务中断或其它影响，甲方将提前通过甲方网站www.citicbank.com予以公告或以电话、邮件等方式通知平台和/或乙方，乙方应关注甲方网站公告。在此期间产生的服务中断或不稳定状态，不视为甲方违约。</p>
    <p><strong>第三条 乙方权利义务</strong></p>
    <p>（一）乙方承诺并保证其通过平台向甲方提供的所有相关资料信息均合法、真实、准确、完整和有效。乙方在使用本协议项下服务过程中，所提供的资料信息如有更改，例如基本注册信息变更、联系信息变更、预留手机号码变更、绑定的账号变更等，应及时按照甲方要求办理有关手续。如因乙方提供的资料和信息不及时/不准确/不完整等原因产生的一切后果，由乙方自行承担。若因此导致甲方遭受损失的，甲方有权要求乙方赔偿。</p>
    <p>（二）乙方知悉并同意，甲方仅按照平台通过系统接口发送的申请或指令以及其他甲方认可的方式接受的平台指令办理资金划转及账务明细登记等业务，甲方不负责监管和审核乙方与平台之间的交易过程和交易结果，若因平台相关数据/指令发生错误、未经授权或平台及其授权的技术服务商系统发生故障等原因导致的任何风险和损失，均由乙方与平台自行解决，甲方不承担任何责任。</p>
    <p>（三）乙方对通过平台系统向甲方系统发送的电子业务指令所涉数据内容的真实性和有效性负责。乙方确保通过甲方进行的资金交易具有真实合法的交易背景，就本协议下涉及的每一笔交易和行为，乙方向甲方负连带责任。</p>
    <p>（四）乙方知悉并同意，乙方与平台、其他相关方之间的任何争议、纠纷、诉讼、仲裁等，均与甲方无关，由乙方及其相关各方自行解决。甲方既不参与也不对此承担任何责任和义务。若因此导致甲方遭受损失的，甲方有权要求乙方赔偿。</p>
    <p>（五）乙方授权平台通过平台系统接口传输等方式向甲方提供乙方信息，以便甲方对乙方身份及账户等信息进行核验，上述信息包括乙方姓名或名称、证件类型、证件号码、商户编号、商户简称、行业类别、所在地区、详细地址、邮箱、联系电话、账户名称、账号，法定代表人/负责人姓名、证件类型、证件号码、手机号；乙方同意甲方根据乙方提供的联系电话（包括单位和个人）进行实名查证。</p>
    <p>（六）甲方依据乙方提供的信息，包括乙方姓名或名称、证件类型、证件号码、法定代表人名称、法定代表人证件号码（如有）、手机号码、账户信息等必要的信息，用于核实所输银行卡是否为用户本人银行卡，核验乙方身份信息是否准确。甲方负责收集上述信息，通过合作的合法机构（包括且不限于中国银联）提交发卡机构，发卡机构将上述信息用于一致性比对，通过合法机构返回核验结果。乙方同意并授权甲方合作的合法机构、发卡机构基于本协议核验身份之需在各自业务职责范围内采集、使用上述信息。</p>
    <p>（七）乙方有义务确保在平台上的交易真实、合法、合规，因乙方违法违规造成的被甲方协同平台采取核查、延迟资金结算、限制资金结算金额、禁止资金结算、暂停交易或终止本协议项下的服务、报送有关监管部门及公检法部门等所有甲方认为有必要的措施而带来的后果，均由乙方自行承担。</p>
    <p>（八）乙方应保证其指定的平台子商户结算账户是真实、合法、合规和准确的，甲方对乙方资金登记簿进行的出金操作，仅能将款项支付到该指定的平台子商户结算账户。</p>
    <p>（九）乙方不正当使用甲方提供的服务，包括但不限于非基于真实交易背景或业务规则向甲方发送资金划拨指令等，甲方有权取消对乙方提供的相关服务，乙方对此不持任何异议。</p>
    <p>（十）甲方基于合理原因（包括但不限于监管原因、风险管理、消费者权益保护、业务需要等）进行的产品功能升级/改造，乙方应按甲方要求进行配合，甲方有权根据升级/改造工作的实际需要暂停对乙方提供相关服务，直至相关产品功能升级/改造完成。如乙方无合理原因拒绝配合甲方进行相关功能升级/改造，甲方有权中止或终止为乙方办理本协议项下业务。</p>
    <p>（十一）乙方应遵守中华人民共和国反洗钱法律法规，不参与涉嫌洗钱、恐怖融资、扩散融资等违法犯罪活动；主动配合甲方客户身份识别与尽职调查，提供真实、准确、完整客户资料，遵守甲方反洗钱与反恐怖融资相关管理规定。对具备合理理由怀疑涉嫌洗钱、恐怖融资的客户，甲方将按照中国人民银行反洗钱监管规定采取必要管控措施。</p>
    <p>（十二）乙方承诺并保证，在遵守相关法律法规和本协议约定的有关信息保密要求的前提下，乙方应协助配合甲方开展的尽职调查和可疑交易甄别工作，并根据甲方要求提供相关信息，乙方应对相关信息的真实性、完整性、准确性负责；发生或可能发生洗钱风险事件的，乙方同意甲方有权按照反洗钱相关管理规定，对乙方账户及资金登记簿采取限制转账金额、转账频率、暂禁等管控措施。</p>
    <p><strong>第四条 违约责任</strong></p>
    <p>（一）甲方不承担乙方、平台商务行为及资金管理运用的任何风险或责任，甲方不负责审核平台交易系统中的交易信息及数据、乙方的真实身份及在平台的交易账户信息，不对由乙方及平台生成、存储、控制的相关数据和信息的真实性、准确性负责。若因乙方或平台欺诈、管理不严、疏忽大意、平台系统故障或相关数据/指令发生错误导致的任何风险和损失，均由乙方或平台承担。</p>
    <p>（二）因下列原因导致甲方无法正常提供本协议项下服务的，甲方不承担任何责任：</p>
    <p>1.甲方接收到的指令信息不明、存在乱码、不完整、无法辨认或存在明显信息不匹配等错误的；</p>
    <p>2.交易资金账户、自有资金账户或资金登记簿余额不足，无法完成资金划转的；</p>
    <p>3.交易资金账户、自有资金账户或平台子商户结算账户被依法冻结或被有权机关采取其它限制性措施的；</p>
    <p>4.乙方操作不当或操作失误的；</p>
    <p>5.不可抗力或其它不可归因于甲方的情况。</p>
    <p>（三）乙方违反本协议约定的，甲方有权要求违约方立即纠正违约行为，同时有权解除本协议并终止本协议项下的业务服务，且无需承担任何违约责任。</p>
    <p><strong>第五条 保密条款</strong></p>
    <p>（一）双方因本协议而获悉对方之商业秘密、技术、文件或其他保密资料以及本协议（包括但不限于：纸制文件及其他介质文件和数据）等，非经对方书面同意，不得用作本协议以外的其他目的，且不得泄露与任何第三方，否则视为违约。</p>
    <p>（二）出现下述情形之一的，不视为违反保密义务：</p>
    <p>1.所涉信息已成为公开渠道可以获取的信息；</p>
    <p>2.所涉信息经双方一致认为不属于保密范围内的信息；</p>
    <p>3.所涉信息为一方为履行工作职责而向需知保密信息的本方雇员或为本方提供法律服务、审计服务等中介服务的机构提供，但该方仍需保证本方雇员和中介服务机构按照本协议约定承担保密义务；</p>
    <p>4.一方根据国家法律法规、行政规章或其他规范性文件或有关政府机关或监管部门的规定或指令需向第三方或公众披露相关保密信息的。</p>
    <p>如果本协议任何一方能够证明存在第4项之情形，则其可以披露保密信息，但在相关法律法规及有权机关允许的前提下，在披露之前需书面通知另一方并说明需要披露的具体内容及理由。</p>
    <p>（三）除法律法规另有规定外，本协议履行完毕或解除、终止后，接受方应立即向披露方返还保密信息；对于不能返还的保密信息，接受方应立即予以销毁。</p>
    <p>（四）任何一方违反本协议项下的保密义务给另一方造成损失的，违约方应向守约方承担赔偿责任。</p>
    <p>（五）本协议的解除、终止、失效不影响本协议保密条款的效力。</p>
    <p><strong>第六条 法律适用与争议解决</strong></p>
    <p>（一）本协议的签订、成立、生效、解释，履行、终止以及争议之解决均适用中华人民共和国法律（为本协议之目的，不包括香港特别行政区、澳门特别行政区和台湾地区法律）。</p>
    <p>（二）各方就本协议发生纠纷的，应通过友好协商解决；协商不成的，任何一方均可向甲方所在地有管辖权的人民法院提起诉讼。</p>
    <p><strong>第七条 通知条款</strong></p>
    <p>甲方有权依据法律、法规、规章或业务需要对本协议及各类规则不时进行调整或修改，涉及乙方权利义务变更的调整或修改，将以网站公示或通过平台向乙方发送通知的方式告知，甲方不再单独向乙方发送通知。自公告施行之日或平台通知送达之日起公告内容构成对各方协议约定的有效修改和补充。如果乙方不同意接受调整或修改的内容，应当立即停止使用甲方本协议项下服务，甲方对此不承担任何法律责任和费用补偿。乙方继续使用甲方本协议项下服务的，即视为乙方接受经调整或修改的协议和规则。</p>
    <p><strong>第八条 协议的生效及效力</strong></p>
    <p>（一）本协议由乙方在平台提供的系统服务界面通过网络点击"签署"或"同意"的方式签署，于系统记录的签约日期之日起发生法律效力。</p>
    <p>（二）如甲方与平台签署的合作协议失效，或乙方与平台之间的服务协议失效或发生其他乙方与平台合作终止的情况，则本协议也随之失效。</p>
    <p><strong>第九条 其他约定</strong></p>
    <p>（一）甲方因法律法规、监管规定变化或者监管部门要求，不能履行或不能按照本协议约定履行相关义务的，甲方有权终止或依据法律法规、监管规定变化或监管部门要求变更履行本协议。因该种原因致协议终止或变更使甲方不能履行或不能按照协议约定履行管理义务的，甲方免除责任。</p>
    <p>（二）本协议项下各项服务中包括但不限于文字、软件、声音、图片、广告、图表、邮件等内容均受版权、商标、标签和其他财产所有权等有关法律的保护，甲方依法对相关内容享有一切权利。</p>
    <p>甲方已采取加粗、加黑、突出显示等合理方式提请乙方注意本协议项下免除或限制其责任的条款，并按乙方要求对有关条款予以充分说明；乙方已阅读本协议所有条款，对本协议条款的含义及相应的法律后果已全部通晓并充分理解，同意遵守本协议条款。甲乙双方对本协议所有条款内容的理解不存在异议。</p>
  </div>
</template>

<script>
export default {
  name: 'WalletAgreement'
}
</script>

<style scoped>
.wallet-agreement {
  padding: 16px;
  line-height: 1.8;
  font-size: 14px;
  max-width: 100%;
  overflow-x: hidden;
  word-wrap: break-word;
  word-break: break-all;
}

.wallet-agreement h1 {
  font-size: 18px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
  word-wrap: break-word;
}

.wallet-agreement p {
  margin-bottom: 8px;
  text-indent: 2em;
  word-wrap: break-word;
  word-break: break-all;
}

.wallet-agreement p strong {
  display: block;
  margin-top: 12px;
  margin-bottom: 8px;
  font-weight: bold;
}
</style>
